import { render, staticRenderFns } from "./monitorEdit.vue?vue&type=template&id=74852a52&scoped=true&"
import script from "./monitorEdit.vue?vue&type=script&lang=js&"
export * from "./monitorEdit.vue?vue&type=script&lang=js&"
import style0 from "./monitorEdit.vue?vue&type=style&index=0&id=74852a52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74852a52",
  null
  
)

export default component.exports